import ListPage from '@/pages/seo-templates-topic/ListPage'
import CreateUpdatePage from '@/pages/seo-templates-topic/CreateUpdatePage'

export default [
  {
    path: '/seo-templates/topic-city/list',
    name: 'SeoTemplatesTopicList',
    component: ListPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/seo-templates/topic-city/create',
    name: 'CreateSeoTopicTemplate',
    component: CreateUpdatePage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/seo-templates/topic-city/update/:id',
    name: 'UpdateSeoTopicTemplate',
    component: CreateUpdatePage,
    meta: {
      requiresAuth: true,
    },
  },
]


